"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtSchedule = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtSchedule = function SvgBtSchedule(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.854 12.1472C13.659 11.9522 13.342 11.9512 13.146 12.1462L11.5 13.7932L10.854 13.1462C10.659 12.9512 10.342 12.9512 10.147 13.1462C9.95201 13.3412 9.95201 13.6582 10.147 13.8532L11.147 14.8532C11.244 14.9512 11.372 15.0002 11.5 15.0002C11.628 15.0002 11.756 14.9512 11.854 14.8542L13.854 12.8542C14.049 12.6592 14.049 12.3422 13.854 12.1472Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.854 16.1472C13.659 15.9522 13.342 15.9512 13.146 16.1462L11.5 17.7932L10.854 17.1472C10.659 16.9522 10.342 16.9522 10.147 17.1472C9.95201 17.3422 9.95201 17.6592 10.147 17.8542L11.147 18.8542C11.244 18.9512 11.372 19.0002 11.5 19.0002C11.628 19.0002 11.756 18.9512 11.854 18.8542L13.854 16.8542C14.049 16.6592 14.049 16.3422 13.854 16.1472Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.5 13H15.5C15.224 13 15 13.224 15 13.5C15 13.776 15.224 14 15.5 14H17.5C17.776 14 18 13.776 18 13.5C18 13.224 17.776 13 17.5 13Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.5 17H15.5C15.224 17 15 17.224 15 17.5C15 17.776 15.224 18 15.5 18H17.5C17.776 18 18 17.776 18 17.5C18 17.224 17.776 17 17.5 17Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 8H17V7.5C17 7.224 16.776 7 16.5 7H15.415C15.208 6.418 14.652 6 14 6C13.348 6 12.792 6.418 12.585 7H11.5C11.224 7 11 7.224 11 7.5V8H9C8.449 8 8 8.449 8 9V21C8 21.551 8.449 22 9 22H19C19.551 22 20 21.551 20 21V9C20 8.449 19.551 8 19 8ZM12 8H13C13.276 8 13.5 7.776 13.5 7.5C13.5 7.224 13.724 7 14 7C14.276 7 14.5 7.224 14.5 7.5C14.5 7.776 14.724 8 15 8H16V9H12V8ZM19 21H9V9H11V9.5C11 9.776 11.224 10 11.5 10H16.5C16.776 10 17 9.776 17 9.5V9H19V21Z",
    fill: "currentColor"
  }));
};

exports.SvgBtSchedule = SvgBtSchedule;